import InsightsHorizontalImageSplitHero from './InsightsHorizontalImageSplitHero';

export { type InsightsHorizontalImageSplitHeroProps } from './InsightsHorizontalImageSplitHero';
export default InsightsHorizontalImageSplitHero;
